import React from 'react';
import ReactDOM from 'react-dom';
import AppHeader from './components/AppHeader';
import AppFooter from './components/AppFooter';
import '../styles/wordpress.scss';

const headerNode = document.getElementById('cccisd-header');
if (headerNode) {
    ReactDOM.render(<AppHeader />, headerNode);
}

const footerNode = document.getElementById('cccisd-footer');
if (footerNode) {
    ReactDOM.render(<AppFooter />, footerNode);
}
